import { Component, OnInit } from '@angular/core';
import { ESTATUS_CARD_DATA, ESTATUS_INFO_TEXT, FAQ_CARD, PENSION_PROCESS_RESPONSE, RESPONSE_TRACKING, VEJEZ_EDAD } from '@constants/tramite-pension-constant';
import { IEstadoTramitePensionResponse } from '@interfaces/estado-tramite-pension.response.interface';
import { StorageService } from '@services/storage/storage.service';
import { IFaqItem } from '@shared/common/interfaces/faq-card.interface';
import { IEstatusCardDetail } from '@shared/common/interfaces/status-card.interface';
import { Util } from '@shared/common/utils/util';
import { EstadoTramiteStepperService } from '../../services/estado-tramite-stepper.service';
import { IPensionTramiteResponse } from '@shared/common/interfaces/pension-tramite.interface';

@Component({
  selector: 'app-inicio-tramite-pension',
  templateUrl: './inicio-tramite-pension.component.html',
  standalone: false
})
export class InicioTramitePensionComponent implements OnInit {
  titleFaq: string = '';

  statusCardData = ESTATUS_CARD_DATA[0];

  faqCardData: IFaqItem[] = [];

  constructor(private readonly tramiteStepper: EstadoTramiteStepperService,
    private readonly storageService: StorageService,
    private readonly util: Util,
  ) { }

  ngOnInit() {
    this.tramiteStepper.setStepCurrent(1);
    this.faqCardData = FAQ_CARD[0].questions[0].items;
    this.titleFaq = FAQ_CARD[0].questions[0].title;
    void this.getDataInfoTramite();
  }

  async getDataInfoTramite() {
    const responseTracking: IEstadoTramitePensionResponse = await this.storageService.get(RESPONSE_TRACKING);
    let fechaSolicitudTramite = responseTracking?.data?.tramite?.fechaSolicitudTramite;

    if (!fechaSolicitudTramite) {
      const tramitePension: IPensionTramiteResponse = await this.storageService.get(PENSION_PROCESS_RESPONSE);
      fechaSolicitudTramite = tramitePension?.PensionesEnTramite[0]?.fechaSolicitudTramite;
    }

    this.statusCardData.details = this.getDetailsStatusCard(
      fechaSolicitudTramite,
    );
    this.statusCardData.infoBoxMessage = responseTracking?.data?.resumen ?? '';
    this.statusCardData.infoText = ESTATUS_INFO_TEXT[VEJEZ_EDAD] ?? '';
  }

  private getDetailsStatusCard(fechaBase?: string | null): IEstatusCardDetail[] {
    const fechaInicio = this.util.formatearFechaParaVista(fechaBase);

    const fechaFin = this.util.addBusinessDays(fechaInicio, 10);

    return [
      {
        label: 'Fecha inicio trámite de pensión',
        value: fechaInicio || 'Fecha no disponible',
        isHeader: false,
      },
      {
        label: 'Fecha estimada de entrega de Certificado de Saldos',
        value: fechaFin || 'Fecha no disponible',
        isHeader: false,
      },
      {
        label: 'Solicita el Certificado de Saldos mediante',
        value: 'Video Atención o Sucursal de AFP Capital',
        isHeader: false,
      }
    ];
  }
}
